import { render, staticRenderFns } from "./HandleFormSectionsModal.vue?vue&type=template&id=f515e0c0"
import script from "./HandleFormSectionsModal.vue?vue&type=script&lang=js"
export * from "./HandleFormSectionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports